import { FC, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router";

import { AuthenticationContext } from "@/context";

import MainRoutes from "./MainRoutes";

const AppRoutes: FC = (props) => {
  const routeProps = { ...props };

  const location = useLocation();
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const { refreshToken } = useContext(AuthenticationContext);

  useEffect(() => {
    function reset(): void {
      if (timeoutRef.current === null) return;

      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    function queue(): void {
      timeoutRef.current = setTimeout(() => {
        refresh();
      }, 5000);
    }

    async function refresh(): Promise<void> {
      reset();
      await refreshToken();
      queue();
    }

    queue();
    return reset;
  }, [location]);

  return <MainRoutes {...routeProps} />;
};

export default AppRoutes;
